<div class="app-shell">
  <app-header
    [environmentLabel]="environmentLabel"
    (searchClick)="onSearch()">
  </app-header>

  <app-breadcrumb></app-breadcrumb>

  <main class="app-shell__main">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>

  <!-- Global toast: top-right, offset below the sticky 60px header ribbon. -->
  <p-toast position="top-right" styleClass="app-toast"></p-toast>
</div>
